import {
  IsDefined,
  IsInt,
  IsOptional,
  IsString,
  Length,
  Max,
  Min
} from 'class-validator';
import { DriverInformationBaseDto } from './driver-information-base.dto';

/**
 * DTO object for creation of Driver Assignment to Merchant.
 */
export class DriverInformationForUpdateDto extends DriverInformationBaseDto {
  @IsInt()
  @Min(1)
  @Max(2147483647) // MySql INT(11) max value
  @IsDefined()
  driverId: number;

  @IsString()
  @IsOptional()
  @Length(0, 250)
  driverLastName?: string;

  @IsString()
  @IsOptional()
  @Length(0, 50)
  driverPhoneNumber?: string;
}
